export default {
    container: {
        display: "flex",
        width: "100%",
    },
    textAreaStyle: {
        resize: "both",
        flex: 1,
    },
    noMarginBottom: {
        marginBottom: 0,
    }
}